
import Vue from 'vue'
import * as Api from '@/api/SchoolSettingsApi'
import { PageHeader } from '../components'
import { SaveButton, DeleteButton } from '@/components/buttons'
import { SchoolStudentDto } from '@ViewModels/SchoolStudentDto'
import StudentDetailsForm from './forms/StudentDetailsForm.vue'
import { ensureValueIsDate } from '@/services/DateHelpers'

export default Vue.extend({
   name: 'StudentDetails',
   props: {
      schoolId: { type: String, default: '' },
      studentId: String,
      settings: { type: Boolean, default: false}
   },
   data() {
      return {
         editingItem: {} as SchoolStudentDto,
         loading: true,
         saving: false,
      }
   },
   computed: {
      activeSchoolId(): string {
         return this.schoolId ? this.schoolId : this.$store.getters.activeSchoolId
      },
      userIsiUgoAdmin(): boolean {
         return this.$store.getters.userIsiUgoAdmin
      },
      canSave(): boolean {
         return (
            !!this.editingItem &&
            !!this.editingItem.FirstName &&
            !!this.editingItem.LastName &&
            this.editingItem.ClassRoomIds.length > 0
         )
      },
      isNew(): boolean {
         return this.studentId === 'new'
      },
      crumbs(): Breadcrumb[] {
         return [
            {
               text: 'Students',
               route: 'student-list',
               params: { schoolId: this.activeSchoolId, settings: this.settings },
            },
            { text: this.isNew ? 'New Student' : this.editingItem.Name },
         ]
      },
   },
   mounted() {
      if (this.isNew) {
         this.createDefaultItem()
      } else {
         this.loadItem()
      }
   },
   methods: {
      async saveItem() {
         try {
            this.saving = true
            await Api.saveSchoolStudent(this.editingItem)
            this.$router.push({
               name: 'student-list',
               params: { schoolId: this.activeSchoolId, settings: this.settings } as any,
            })
         } catch {
            this.saving = false
         }
      },

      async deleteItem() {
         try {
            await Api.deleteSchoolStudent(this.studentId)
            this.$router.push({
               name: 'student-list',
               params: { schoolId: this.activeSchoolId, settings: this.settings } as any,
            })
         } catch {
            // nothing to do here
         }
      },

      async loadItem() {
         try {
            const item = await Api.getSchoolStudent(this.studentId)
            if (item.DateOfBirth) {
               item.DateOfBirth = ensureValueIsDate(item.DateOfBirth)
            }
            Vue.$assign(this.editingItem, item)
         } finally {
            this.loading = false
         }
      },

      async createDefaultItem() {
         Vue.$assign(this.editingItem, this.$store.getters.emptySchoolStudentDto)
         this.editingItem.SchoolId = this.activeSchoolId
         this.editingItem.IsEnabled = true
         this.editingItem.ClassRoomIds = this.$store.getters.classroomIdsFilter
         this.loading = false
      },
   },
   components: {
      PageHeader,
      DetailsForm: StudentDetailsForm,
      SaveButton,
      DeleteButton,
   },
})
